module.exports = __webpack_public_path__ + "media/vellofent_EN_no_67.2a503b02.mp4";